<template>
  <div
    class="watermark"
    :style="{ height: windowHeight + 'px', width: windowWidth + 'px' }"
  >
    <div class="watermark_0" v-if="waterMarkType == 0">
      <div
        class="watermark_item_c"
        v-for="index in waterMarkCount"
        :style="{
          width: waterMarkWidth + 'px',
          height: waterMarkHeight + 'px',
          left: ((index - 1) % waterMarkColumn) * waterMarkWidth + 'px',
          top:
            parseInt((index - 1) / waterMarkColumn) * waterMarkHeight -
            50 +
            'px'
        }"
        :key="index"
      >
        <div
          class="watermark_item"
          :style="{ paddingTop: waterMarkHeight / 2 + 'px' }"
          :class="{ white: index % 2 == 0 }"
        >
          <strong>{{ name }}</strong>
          <em>{{ phone | showPhoneOrEmail(email) }}</em>
          <span>{{ loginTime }}</span>
        </div>
      </div>
    </div>
    <div class="watermark_1" v-if="waterMarkType == 1">
      <div
        v-for="row in waterMarkRow"
        :key="row"
        :style="{ height: warterRowHeight + 'px' }"
      >
        <div
          class="watermark_item_c"
          v-for="index in row % 2 == 1 ? waterMarkColumn : waterMarkColumn - 1"
          :style="{
            width: waterMarkWidth + 'px',
            height: waterMarkHeight + 'px',
            left:
              ((index - 1) % waterMarkColumn) * waterMarkWidth +
              (row % 2 == 1 ? 0 : waterMarkWidth * 0.4) +
              'px',
            top: (row - 1) * warterRowHeight - 50 + 'px'
          }"
          :key="index"
        >
          <div
            class="watermark_item"
            :style="{ paddingTop: waterMarkHeight / 2 + 'px' }"
            :class="{ white: index % 2 == 0 }"
          >
            <strong>{{ name }}</strong>
            <em>{{ phone | showPhoneOrEmail(email) }}</em>
            <span>{{ loginTime }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="watermark_2" v-if="waterMarkType == 2">
      <div
        v-for="row in waterMarkRow"
        :key="row"
        :style="{ height: warterRowHeight + 'px' }"
      >
        <div
          class="watermark_item_c"
          v-for="index in waterMarkCount"
          :style="{
            width: waterMarkWidth + 'px',
            height: waterMarkHeight + 'px',
            left: ((index - 1) % waterMarkColumn) * waterMarkWidth + 'px',
            top:
              parseInt((index - 1) / waterMarkColumn) * waterMarkHeight -
              50 +
              'px'
          }"
          :key="index"
        >
          <div
            class="watermark_item"
            :style="{ paddingTop: waterMarkHeight / 2 + 'px' }"
            :class="{ white: index % 2 == 0 }"
          >
            <strong>{{ name }}</strong>
            <em>{{ phone | showPhoneOrEmail(email) }}</em>
            <span>{{ loginTime }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String
    },
    waterMarkType: {
      type: Number,
      default: 0
    },
    isCustom: {
      type: Boolean,
      default: false
    }
  },
  name: "waterMark",
  data() {
    return {
      sessionHeight: 0,
      sessionWidth: window.innerWidth,
      waterMarkCount: 15,
      waterMarkColumn: 5,
      waterMarkRow: 3
    };
  },
  computed: {
    user() {
      return this.$store.getters.user_info;
    },
    name() {
      return this.$store.getters.user_name.toUpperCase();
    },
    phone() {
      return this.$store.getters.user_phone;
    },
    email() {
      return this.$store.getters.user_email;
    },
    loginTime() {
      return this.$cookies.get("kls_user_login_time");
    },
    waterMarkWidth: { 
      get() {
        return (this.windowWidth / this.waterMarkCount) * this.waterMarkRow;
      },
      set(val) {
        return val;
      }
    },
    waterMarkHeight: {
      get() {
        return (this.windowHeight / this.waterMarkCount) * this.waterMarkColumn;
      },
      set(val) {
        return val;
      }
    },
    warterRowHeight() {
      return this.sessionHeight / this.waterMarkRow;
    },
    windowHeight: {
      get() {
        return this.sessionHeight - 20;
      },
      set(newVal) {
        return newVal;
      }
    },
    windowWidth: {
      get() {
        return this.sessionWidth - 20;
      },
      set(val) {
        return val;
      }
    }
  },
  created() {
    // 767
    if (this.waterMarkType == 1) {
      // this.waterMarkCount = 28
      // this.waterMarkColumn = 7
      // this.waterMarkRow = 4

      this.waterMarkCount = 21;
      this.waterMarkColumn = 7;
      this.waterMarkRow = 3;
    } else if (this.waterMarkType == 2) {
      this.waterMarkCount = 36;
      this.waterMarkColumn = 9;
      this.waterMarkRow = 4;
    }

    let self = this;
    //根据type 判断水印
    if (!this.isCustom) {
      if (self.type == "broadcast") {
        self.sessionHeight = window.innerHeight - 170;
      } else if (self.type == "meeting") {
        self.sessionHeight = window.innerHeight - 120;
      }
      window.onresize = () => {
        self.sessionWidth = window.innerWidth;
        //根据type 判断水印
        if (self.type == "broadcast") {
          self.sessionHeight = window.innerHeight - 60;
        } else if (self.type == "meeting") {
          self.sessionHeight = window.innerHeight - 110;
        }
      };
    } else {
      self.sessionHeight = "100%";
      self.sessionWidth = "100%"
    }
  },
  watch: {
    sessionWidth(newVal, oldVal) {
      let self = this;
      self.windowWidth = newVal - 20;
      self.waterMarkWidth =
        (self.windowWidth / self.waterMarkCount) * self.waterMarkRow;
    },
    sessionHeight(newVal, oldVal) {
      let self = this;
      self.windowHeight = newVal - 20;
      self.waterMarkHeight =
        (newVal / self.waterMarkCount) * self.waterMarkColumn;
    }
  },
  // mounted() {

  // },
  filters: {
    showPhoneOrEmail(phone, email) {
      let tmp = email == null ? "" : email.toLowerCase();
      if (tmp.indexOf("@nike.com") >= 0) {
        return email;
      } else {
        return phone;
      }
    }
  }
};
</script>
<style lang="less" scoped>
// //7*4 0.5
// @watermark_font_size: 1vw;
// @watermark_line_height: 1.5vw;
// @watermark_login_time_font_size: 0.8vw;
// @watermark_opacity: 0.5;
//5*3 0.5
@watermark_font_size_0: 1.5vw;
@watermark_line_height_0: 2vw;
@watermark_login_time_font_size_0: 1vw;
@watermark_opacity_0: 0.4;
//7*3 0.5
@watermark_font_size_1: 1.2vw;
@watermark_line_height_1: 1.5vw;
@watermark_login_time_font_size_1: 0.9vw;
@watermark_opacity_1: 0.4;
// //5*3 1
// @watermark_font_size: 1.5vw;
// @watermark_line_height: 2vw;
// @watermark_login_time_font_size: 1vw;
// @watermark_opacity: 1;
//9*4 0.5
@watermark_font_size_2: 1vw;
@watermark_line_height_2: 1vw;
@watermark_login_time_font_size_2: 0.8vw;
@watermark_opacity_2: 0.4;

.watermark {
  pointer-events: none;
  width: 100%;
  overflow: hidden;
  position: relative;

  .watermark_0 {
    .watermark_item_c {
      transform: rotate(-45deg);
      position: absolute;
      opacity: @watermark_opacity_0;

      .watermark_item {
        color: #1f1f1f;
        width: 140px;
        margin: 0 auto;
        text-align: left;

        * {
          display: block;
          font-style: normal;
          white-space: nowrap;
        }

        strong {
          font-size: @watermark_font_size_0;
          line-height: @watermark_line_height_0;
          font-weight: normal;
        }

        em {
          font-size: @watermark_font_size_0;
          line-height: @watermark_line_height_0;
        }

        span {
          font-size: @watermark_login_time_font_size_0;
          line-height: @watermark_line_height_0;
        }

        &.white {
          color: #757575;
        }
      }
    }
  }

  .watermark_1 {
    .watermark_item_c {
      transform: rotate(-45deg);
      position: absolute;
      opacity: @watermark_opacity_1;

      .watermark_item {
        color: #1f1f1f;
        width: 140px;
        margin: 0 auto;
        text-align: left;

        * {
          display: block;
          font-style: normal;
          white-space: nowrap;
        }

        strong {
          font-size: @watermark_font_size_1;
          line-height: @watermark_line_height_1;
          font-weight: normal;
        }

        em {
          font-size: @watermark_font_size_1;
          line-height: @watermark_line_height_1;
        }

        span {
          font-size: @watermark_login_time_font_size_1;
          line-height: @watermark_line_height_1;
        }

        &.white {
          color: #757575;
        }
      }
    }
  }

  .watermark_2 {
    .watermark_item_c {
      transform: rotate(-45deg);
      position: absolute;
      opacity: @watermark_opacity_2;

      .watermark_item {
        color: #1f1f1f;
        width: 140px;
        margin: 0 auto;
        text-align: left;

        * {
          display: block;
          font-style: normal;
          white-space: nowrap;
        }

        strong {
          font-size: @watermark_font_size_2;
          line-height: @watermark_line_height_2;
          font-weight: normal;
        }

        em {
          font-size: @watermark_font_size_2;
          line-height: @watermark_line_height_2;
        }

        span {
          font-size: @watermark_login_time_font_size_2;
          line-height: @watermark_line_height_2;
        }

        &.white {
          color: #757575;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/waterMark.vue